export default __webpack_public_path__ + "static/icon-1-6-94ea6bd389425b35d16ce6e11c8ed164.png";